import { EntityDeletionState, Service, ServiceType } from '@mews-commander/data-access';
import { useProductsSuspenseQuery } from '@mews-commander/legacy-entities/src/queries/productsQuery';
import { useServicesSuspenseQuery } from '@mews-commander/legacy-entities/src/queries/services/servicesQuery';

const getActiveServices = (services: Service[]) => services.filter(({ isActive }) => isActive);
const getServiceIds = (services: Service[]) => services.map(({ id }) => id);

export const useProductsActiveServices = () => {
    const {
        data: { services },
    } = useServicesSuspenseQuery({
        serviceType: ServiceType.Bookable,
        serviceDeletionState: EntityDeletionState.Everything,
    });

    const activeServices = getActiveServices(services);
    const serviceIds = getServiceIds(activeServices);

    const {
        data: { products },
    } = useProductsSuspenseQuery({ serviceIds, extent: { baseProducts: true } }, { enabled: !!serviceIds?.length });

    return { services: activeServices, products };
};
